import { Inject, Injectable, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from '../../shared/appconfig/appconfig.service'

import { Connector, ConnectorDefinition } from '../models/connector.model';

@Injectable({
  providedIn: 'root'
})
export class ConnectorService {

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
  }


  getUrl(): string {
    return AppConfigService.settings.get('chatstyleapiServer');
  }

  public connectorDef: ConnectorDefinition = {
    id: 0,
    connectorDefinitionID: '',
    type: '',
    connectorType: '',
    cardImageUrl: '',
    cardStyle: '',
    iconName: '',
    description: '',
    imageUrl: '',
    name: '',
    active: true,
    testUrl: '',
    siteUrl: '',
    companyID: '',
    companyName: '',
    publicKey: '',
    privateKey: '',
    hostName: '',
    port: 0,
    secure: false,
    userName: '',
    password: '',
    secret: '',
    appID: '',
    userID: '',
    scriptObjectTypeName: '',
    typeName: '',
    token: '',
    lastVerified: '',
    data: '',
    subscribe: false,
    fromTemplate: false,
    manifestUrl: '',
    canTest: false,
    customized: false,
    isDefault: false
  };

  empty(): ConnectorDefinition {
    return this.connectorDef;
  }

  get(): Observable<Connector[]> {
    return this.http.get<Connector[]>(this.getUrl() + 'connectors');
  }

  enableConnectors(botId: string): Observable<Object> {
    return this.http.post(this.getUrl() + 'connectors/bot/' + botId, {});
  }

  deleteConnectors(botId: string): Observable<Object> {
    return this.http.delete(this.getUrl() + 'connectors/bot/' + botId);
  }

  deleteConnector(id: number | string): Observable<Object> {
    return this.http.delete(this.getUrl() + 'connectors/' + id);
  }

  getDefinitions(group: string): Observable<Connector[]> {
    return this.http.get<Connector[]>(this.getUrl() + 'connectors/definitions/' + group);
  }

  getConnector(id: string): Observable<ConnectorDefinition> {
    const url = 'connectors/' + id;
    return this.getInternal(url);
  }

  getNew(type: string, id: string): Observable<ConnectorDefinition> {
    const url = 'connectors/new/' + type + '/' + id;
    return this.getInternal(url);
  }

  set(connector: ConnectorDefinition): Observable<ConnectorDefinition> {
    const url = 'connectors/' + connector.id;
    return this.setInternal(url, connector);
  }

  /**
   * Checks a connector's credentials with the provider before anything is saved (CHAT-1232).
   * Completes only when the provider accepted them: 422 means it refused them, anything else
   * failed to reach an answer.
   */
  verifyCredentials(connectorDefinitionId: string, connector: ConnectorDefinition): Observable<unknown> {
    return this.http.post(this.getUrl() + 'connectors/verify/' + connectorDefinitionId, connector);
  }

  test(connector: ConnectorDefinition): Observable<ConnectorDefinition> {
    const url = 'connectors/' + connector.id + '/test';

    return this.http.post<ConnectorDefinition>(this.getUrl() + url, {});
  }

  activate(connector: ConnectorDefinition, botId: string, state: string): Observable<ConnectorDefinition> {
    const url = 'connectors/' + connector.id + '/activate/' + state;

    return this.http.get<ConnectorDefinition>(this.getUrl() + url);
  }

  newConnector(connector: ConnectorDefinition): Observable<ConnectorDefinition> {
    const url = 'connectors/new/' + connector.connectorType + '/' + connector.connectorDefinitionID;
    return this.setInternal(url, connector);
  }

  getInternal(url: string): Observable<ConnectorDefinition> {
    return this.http.get<ConnectorDefinition>(this.getUrl() + url);
  }

  setInternal(url: string, connector: ConnectorDefinition): Observable<ConnectorDefinition> {
    return this.http.post<ConnectorDefinition>(this.getUrl() + url,
      connector);
  }


}


